<template>
    <v-list dense v-if="paymentMethods" class="pa-0">
      <template v-if="paymentMethod === paymentMethods.bankTransfer.identifier">
        <v-list-item v-if="paymentMethods.bankTransfer.titular">
          <v-list-item-title :style="{maxWidth:'120px'}" class="font-weight-medium subtitle-1">Titular</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium subtitle-1">{{ paymentMethods.bankTransfer.titular }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="paymentMethods.bankTransfer.cbu">
          <v-list-item-title :style="{maxWidth:'120px'}" class="font-weight-medium subtitle-1">CBU</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium subtitle-1">{{ paymentMethods.bankTransfer.cbu }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="paymentMethods.bankTransfer.alias">
          <v-list-item-title :style="{maxWidth:'120px'}" class="font-weight-medium subtitle-1">Alias</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium subtitle-1">{{ paymentMethods.bankTransfer.alias }}</v-list-item-subtitle>
        </v-list-item>
      </template>

      <template v-if="paymentMethod === paymentMethods.mercadoPagoTransfer.identifier">
        <v-list-item v-if="paymentMethods.mercadoPagoTransfer.titular">
          <v-list-item-title :style="{maxWidth:'120px'}" class="font-weight-medium subtitle-1">Titular</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium subtitle-1">{{ paymentMethods.mercadoPagoTransfer.titular }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="paymentMethods.mercadoPagoTransfer.cvu">
          <v-list-item-title :style="{maxWidth:'120px'}" class="font-weight-medium subtitle-1">CVU</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium subtitle-1">{{ paymentMethods.mercadoPagoTransfer.cvu }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="paymentMethods.mercadoPagoTransfer.alias">
          <v-list-item-title :style="{maxWidth:'120px'}"  class="font-weight-medium subtitle-1">Alias</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium subtitle-1">{{ paymentMethods.mercadoPagoTransfer.alias }}</v-list-item-subtitle>
        </v-list-item>
      </template>

      <v-list-item v-if="amount">
        <v-list-item-title :style="{maxWidth:'120px'}" class="font-weight-medium subtitle-1">Monto</v-list-item-title>
        <v-list-item-subtitle class="font-weight-medium subtitle-1">${{ amount }}</v-list-item-subtitle>
      </v-list-item>
    </v-list>
</template>

<script>
export default {
  name: "PaymentData",
  props: {
    paymentMethod: {type: String},
    amount: {type: Number}
  },
  computed: {
    paymentMethods() {
      return this.$store.getters.getPaymentMethods
    },
    isPaymentDataRequired(){
      if(this.paymentMethod === this.paymentMethods.bankTransfer.identifier || this.paymentMethod === this.paymentMethods.mercadoPagoTransfer.identifier){
        return true
      }
      return false
    }
  },
  created() {
    if (this.paymentMethods === null) {
      this.$store.dispatch('findPaymentMethods')
    }
  },
}
</script>

<style scoped>

</style>
